// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"9e0125e4","268":"e469a36f"}[chunkId] + ".chunk.js";
};